// export const REST_API = 'http://localhost:4000';
// export const REST_API_ENDPOINT = 'http://localhost:4000/webservices';

export const VERSION = '1.58';

// AI Analytics (trading) is served through the Node backend at /api/sefi/*
// (see _apis_/aiAnalytics.js). The frontend no longer calls FastAPI :8000 directly.

export const REST_API = 'https://new-al-ikhtayar.skyniche.website/backend';
export const REST_API_ENDPOINT = 'https://new-al-ikhtayar.skyniche.website/backend/webservices';